import type { TOC } from '@ember/component/template-only';
import { PhSquare, PhCheckSquare } from 'ember-phosphor-icons';
import Button from 'tio-ui/components/button';

interface PslfDashboardTodoCheckboxSignature {
  Args: {
    checked: boolean;
    onClick: () => void;
  };
  Element: HTMLButtonElement | HTMLAnchorElement;
}

const PslfDashboardTodoCheckboxComponent: TOC<PslfDashboardTodoCheckboxSignature> = <template>
  <div class="tio-row-center">
    <Button
      @appearance="minimal"
      @intent="default"
      class="mr-2 p-0!"
      ...attributes
      {{on "click" @onClick}}
    >
      {{#if @checked}}
        <PhCheckSquare @size="24" class="shrink-0" />
      {{else}}
        <PhSquare @size="24" class="shrink-0" />
      {{/if}}
    </Button>
  </div>
</template>;

export default PslfDashboardTodoCheckboxComponent;
